<!-- Messages toggle -->
@if (hasPermissionChat()) {
    @if (totalBadgeMessage(); as matBadge) {
        <button
            mat-icon-button
            [matBadge]="matBadge"
            matBadgeColor="warn"
            matBadgePosition="before"
            matBadgeSize="small"
            (click)="openClinicMessage()"
        >
            <mat-icon svgIcon="feather:message-square" />
        </button>
    } @else {
        <button mat-icon-button matBadgeColor="warn" matBadgePosition="before" matBadgeSize="small" (click)="openClinicMessage()">
            <mat-icon svgIcon="feather:message-square" />
        </button>
    }
}
